import * as React from 'react'

import {
  Box,
  RadioButton,
  Text,
  WizardStepRenderParams,
} from '@factorialco/deprecated-design-system'

import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import i18n from 'modules/core/lib/i18n'

import {
  WizardData,
  canRenameFile,
} from 'modules/documents/components/BulkFiles/DocumentLocalStepsModal/types'
import filesStore from 'modules/documents/components/Documents/store'
import { ALL_UPLOAD_TYPES } from 'modules/documents/lib/constants'
import { splitFileName } from 'modules/documents/lib/files/filenameUtils'

const ManualSettings = ({ data, onDataChanged }: WizardStepRenderParams<WizardData>) => {
  const { uploadType } = data

  const changeUploadType = useUnsafeCallback(
    (type: (typeof ALL_UPLOAD_TYPES)[keyof typeof ALL_UPLOAD_TYPES]) => {
      const splittedFilename =
        canRenameFile(type, filesStore.files.length) && filesStore.files[0]?.name
          ? splitFileName(filesStore.files[0]?.name)
          : undefined

      onDataChanged({
        ...data,
        uploadType: type,
        combineFileName: splittedFilename?.fileName,
      })
    },
    [data, onDataChanged]
  )

  const uploadTypes = React.useRef([
    {
      label: i18n.t('split_documents.form.manual_per_file'),
      value: ALL_UPLOAD_TYPES.manual_per_file,
    },
    {
      label: i18n.t('split_documents.form.manual_per_page'),
      value: ALL_UPLOAD_TYPES.manual_per_page,
    },
  ]).current

  const renderTypeOptions = (type: (typeof ALL_UPLOAD_TYPES)[keyof typeof ALL_UPLOAD_TYPES]) => {
    return (
      <Text size="200" weight="normal">
        {type === ALL_UPLOAD_TYPES.manual_per_file
          ? i18n.t('split_documents.form.manual_per_file_description')
          : i18n.t('split_documents.form.manual_per_page_description')}
        {}
      </Text>
    )
  }

  return (
    <Box width="s400" padding="s24">
      <Box gap="s16">
        <Box gap="s8">
          <Text size="200" weight="medium" color="grey1000">
            {i18n.t('split_documents.form.split_settings')}
          </Text>
          <Box
            width="full"
            borderRadius={{ all: 'abs008' }}
            paddingY="s12"
            paddingX="s16"
            gap="s16"
            border={{
              all: {
                width: 's2',
                style: 'solid',
                color: 'grey400',
              },
            }}
          >
            {uploadTypes.map(({ label, value }, index) => {
              return (
                <Box key={index} gap="s2">
                  <RadioButton
                    label={label}
                    value={value}
                    checked={value === uploadType}
                    size="small"
                    onChange={() => changeUploadType(value)}
                  />
                  <Box paddingLeft="s24" gap="s8">
                    {renderTypeOptions(value)}
                  </Box>
                </Box>
              )
            })}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default ManualSettings
